import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateNote, deleteNote, createNote } from '../services/NotesService';
import { getActivityQueryKey } from './useActivitiesQueries';
import useFilters from './useFilters';
import { ActivityPageSize, SorterOptions } from '../constants';
import { useActivityFeedContext } from './useActivityFeedCtx';
export default function useNotesMutations({ buildingId, inspectionId, workOrderId, deficiencyId }) {
    var _a, _b;
    const queryClient = useQueryClient();
    const { data: filters } = useFilters();
    const { scrollToBottom } = useActivityFeedContext();
    const queryKey = getActivityQueryKey(buildingId, { type: (_a = filters === null || filters === void 0 ? void 0 : filters.filters) !== null && _a !== void 0 ? _a : [], sort: (_b = filters === null || filters === void 0 ? void 0 : filters.sort) !== null && _b !== void 0 ? _b : SorterOptions.NewestToOldest }, inspectionId, workOrderId, deficiencyId);
    const { mutateAsync: updateNoteAsync, isLoading: updateNoteLoading } = useMutation({
        mutationFn: updateNote,
        onSuccess: (response) => {
            queryClient.setQueryData(queryKey, (old) => {
                var _a;
                if (!old)
                    return undefined;
                return Object.assign(Object.assign({}, old), { pages: (_a = old === null || old === void 0 ? void 0 : old.pages.map((page) => (Object.assign(Object.assign({}, page), { data: Object.assign(Object.assign({}, page.data), { data: page.data.data.map((note) => (note.id === response.data.id ? response.data : note)) }) })))) !== null && _a !== void 0 ? _a : [] });
            });
        }
    });
    const { mutateAsync: deleteNoteAsync, isLoading: deleteNoteLoading } = useMutation({
        mutationFn: deleteNote,
        onSuccess: (_, variables) => {
            queryClient.setQueryData(queryKey, (old) => {
                var _a;
                if (!old)
                    return undefined;
                return Object.assign(Object.assign({}, old), { pages: (_a = old.pages.map((page) => (Object.assign(Object.assign({}, page), { data: Object.assign(Object.assign({}, page.data), { data: page.data.data.filter((note) => note.id !== variables.id) }) })))) !== null && _a !== void 0 ? _a : [] });
            });
        }
    });
    const { mutateAsync: createNoteAsync, isLoading: createNoteLoading } = useMutation({
        mutationFn: createNote,
        onSuccess: (response) => {
            queryClient.setQueryData(queryKey, (old) => {
                if (!old)
                    return {
                        pages: [
                            {
                                data: {
                                    data: [response.data],
                                    pagination: { totalCount: 1, currentPage: 1, totalPages: 1, pageSize: ActivityPageSize }
                                }
                            }
                        ],
                        pageParams: []
                    };
                const firstPage = old.pages[0];
                return Object.assign(Object.assign({}, old), { pages: [
                        Object.assign(Object.assign({}, firstPage), { data: Object.assign(Object.assign({}, firstPage.data), { data: [response.data, ...firstPage.data.data] }) }),
                        ...old.pages.slice(1)
                    ] });
            });
            scrollToBottom();
        }
    });
    return {
        isLoading: updateNoteLoading || deleteNoteLoading || createNoteLoading,
        updateNote: updateNoteAsync,
        deleteNote: deleteNoteAsync,
        createNote: createNoteAsync
    };
}
